import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
    CoreTypography,
    LoadingButton,
    useTheme
} from '@thriveglobal/thrive-web-leafkit'
import { Box, ButtonProps } from '@mui/material'

const MSFT_LOGO_ROUTE =
    'https://assets.thriveglobal.com/company_logos/ms-symbol-sign-in-button-logo.png'
interface MicrosoftButtonProps extends ButtonProps {
    signInWithMicrosoft: () => void
    ctaText?: string
}

const MicrosoftButton: React.FC<MicrosoftButtonProps> = ({
    signInWithMicrosoft,
    ctaText = null,
    color,
    sx,
    variant
}) => {
    const theme = useTheme()
    return (
        <LoadingButton
            size="large"
            variant={variant || 'contained'}
            color={color}
            loading={false}
            loader={null}
            fixWidth={false}
            onClick={signInWithMicrosoft}
            sx={{
                width: '36rem',
                marginLeft: 'auto',
                marginRight: 'auto',
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                },
                ...sx
            }}
        >
            <Box
                sx={{
                    display: 'flex'
                }}
            >
                <img
                    style={{ paddingRight: '12px' }}
                    src={MSFT_LOGO_ROUTE}
                    alt=""
                    aria-hidden="true"
                />
                <CoreTypography customVariant="buttonLarge">
                    {ctaText ? (
                        ctaText
                    ) : (
                        <FormattedMessage
                            description="Label for button prompting the user to sign in with Microsoft"
                            defaultMessage="Sign in with Microsoft"
                        />
                    )}
                </CoreTypography>
            </Box>
        </LoadingButton>
    )
}

export default MicrosoftButton
